export default {
  en: {
    titleLineOne: 'Create a ClassForKids System',
    titleLineTwo: '',
    subtitle: '',
    suggestionLineOne: 'We suggest no more than a couple of words.',
    suggestionLineTwo: 'Something familiar and simple for you and your customers to easily remember.',
    unavailableTitle: 'Thank you for showing interest in ClassForKids',
    unavailableMessage: 'Please reach out to us',
    unavailableContact: 'to get you started.',
  },
};
